import React, { useEffect, useRef } from 'react';
import { gsap } from "gsap";
import { ScrollTrigger } from 'gsap/ScrollTrigger';

const TextAnimation = ({ children }) => {
const sectionRef = useRef();

  useEffect(() => {
    if (typeof window !== "undefined" && sectionRef.current) {
      // Délai plus long pour être sûr que ScrollTrigger est prêt
      const timer = setTimeout(() => {
        const isSmallScreen = window.innerWidth < 768;
        const elements = sectionRef.current.querySelectorAll('h2, p');
        let animations = []; // Pour stocker les références aux animations

        if (elements.length > 0 && typeof ScrollTrigger !== 'undefined') {
          try {
            elements.forEach((element) => {
              const animation = gsap.fromTo(element, 
                { backgroundSize: isSmallScreen ? '100% 200%' : '0% 100%'}, 
                {
                  backgroundSize: isSmallScreen ? '0% 100% ' : '100% 100%',
                  ease: 'none',
                  scrollTrigger: {
                    trigger: element,
                    start: 'top center',
                    end: 'center center',
                    scrub: true,
                    markers: false,
                  },
                }
              );
              animations.push(animation); // Stocker l'animation pour le nettoyage
            });
            
            // Cleanup
            return () => {
              animations.forEach((animation) => {
                if (animation.scrollTrigger) {
                  animation.scrollTrigger.kill();
                }
                animation.kill();
              });
            };
          } catch (error) {
            // Si ScrollTrigger n'est pas prêt, animation simple
            elements.forEach((element) => {
              gsap.set(element, { backgroundSize: '100% 100%' });
            });
          }
        }
      }, 500); // Délai augmenté à 500ms

      return () => clearTimeout(timer);
    }
  }, []);

  return <div ref={sectionRef}>{children}</div>;
};

export default TextAnimation;


// import React, { useEffect, useRef } from 'react';
// import { gsap } from "gsap";
// import { ScrollTrigger } from 'gsap/ScrollTrigger';

// gsap.registerPlugin(ScrollTrigger);

// const TextAnimation = ({ children }) => {
// const sectionRef = useRef();

//   useEffect(() => {
//     if (typeof window !== "undefined" && sectionRef.current) {
//       const elements = sectionRef.current.querySelectorAll('h2, p');
//       let animations = []; // Pour stocker les références aux animations

//       elements.forEach((element) => {
//         const animation = gsap.fromTo(element, 
//           { backgroundSize: '0% 100%' }, 
//           {
//             backgroundSize: '100% 100%',
//             ease: 'none',
//             scrollTrigger: {
//               trigger: element,
//               start: 'top center',
//               end: 'center center',
//               scrub: true,
//             },
//           }
//         );
//         animations.push(animation); // Stocker l'animation pour le nettoyage
//       });

//       // Cleanup
//       return () => {
//         animations.forEach((animation) => {
//           if (animation.scrollTrigger) {
//             animation.scrollTrigger.kill();
//           }
//           animation.kill();
//         });
//       };
//     }
//   }, []);

//   return <div ref={sectionRef}>{children}</div>;
// };

// export default TextAnimation;

